import { FC } from 'react';
import {
  Modal as ChakraModal,
  ModalOverlay,
  ModalCloseButton,
  ModalBody,
  ModalContent,
  UseModalProps,
  Flex,
} from '@chakra-ui/react';

const Modal: FC<UseModalProps> = ({ children, ...modalProps }) => (
  <ChakraModal {...modalProps}>
    <ModalOverlay />
    <ModalContent>
      <ModalCloseButton />
      <ModalBody minHeight="300px" as={Flex} flexDirection="column">
        {modalProps?.isOpen ? children : null}
      </ModalBody>
    </ModalContent>
  </ChakraModal>
);

export default Modal;
